/**
 * Query key for the unified sidebar badge-count endpoint. Kept in its own dependency-free module so the
 * draft and outbound API clients can invalidate it after a mutation without importing the badges client
 * (which itself imports them) — that would close an import cycle.
 */
export const BADGE_COUNTS_QUERY_KEY = ['badge-counts'] as const;
